import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Gift, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function ConviteHandler() {
  const { codigo } = useParams<{ codigo: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (codigo) {
      // Salvar código no localStorage para usar no cadastro
      localStorage.setItem('fort3d_indicacao', codigo);
    }
  }, [codigo]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center p-4 text-center space-y-8 max-w-2xl mx-auto">
      <div className="w-24 h-24 bg-fort3d-laranja/10 rounded-full flex items-center justify-center animate-bounce">
        <Gift className="w-12 h-12 text-fort3d-laranja" />
      </div>
      
      <div className="space-y-4">
        <h1 className="text-4xl font-black text-gray-900 leading-tight">
          Você ganhou um convite exclusivo da Fort3D!
        </h1>
        <p className="text-xl text-gray-600">
          Cadastre-se hoje e ganhe um desconto especial na sua primeira compra de colecionáveis 3D.
        </p>
      </div>

      <div className="bg-emerald-50 border border-emerald-100 p-6 rounded-2xl w-full">
        <p className="text-emerald-800 font-bold mb-1">🎁 Benefício Ativado</p>
        <p className="text-emerald-600 text-sm">
          Seu bônus de primeira compra será aplicado automaticamente no checkout.
        </p>
      </div>

      <Button 
        size="xl" 
        className="w-full sm:w-auto h-14 px-8 text-lg flex items-center gap-3"
        onClick={() => navigate('/login?acao=cadastro')}
      >
        Acessar Agora
        <ArrowRight className="w-5 h-5" />
      </Button>

      <p className="text-sm text-gray-400">
        Código de indicação: <span className="font-mono">{codigo}</span>
      </p>
    </div>
  );
}
